(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@apollo/client"), require("@duely/core"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["@apollo/client", "@duely/core", "react"], factory);
	else if(typeof exports === 'object')
		exports["@duely/client"] = factory(require("@apollo/client"), require("@duely/core"), require("react"));
	else
		root["@duely/client"] = factory(root["@apollo/client"], root["@duely/core"], root["react"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__209__, __WEBPACK_EXTERNAL_MODULE__218__, __WEBPACK_EXTERNAL_MODULE__156__) => {
return 